import script from "./DataBrowser.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataBrowser.vue?vue&type=script&lang=ts&setup=true"

import "./DataBrowser.vue?vue&type=style&index=0&id=63abf18e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63abf18e"]])

export default __exports__